import { useState, useEffect } from "react";
import { api } from "../api/client";
import { Spinner, FormGroup } from "../components/UI";

export default function Webhooks() {
  const [webhooks, setWebhooks] = useState(null);
  const [deliveries, setDeliveries] = useState(null);
  const [neuUrl, setNeuUrl] = useState("");
  const [neuSecret, setNeuSecret] = useState("");
  const [neuEvents, setNeuEvents] = useState("");

  const laden = () => api.getWebhooks().then(setWebhooks);
  useEffect(() => { laden(); }, []);

  if (!webhooks) return <Spinner />;

  const anlegen = async () => {
    if (!neuUrl.trim() || !neuSecret.trim() || !neuEvents.trim()) return;
    await api.createWebhook({ ziel_url: neuUrl.trim(), secret: neuSecret.trim(), aktive_events: neuEvents.trim() });
    setNeuUrl(""); setNeuSecret(""); setNeuEvents("");
    laden();
  };

  const loeschen = async (id) => {
    if (!window.confirm("Webhook löschen?")) return;
    await api.deleteWebhook(id);
    if (deliveries?.webhookId === id) setDeliveries(null);
    laden();
  };

  const zeigen = async (id) => {
    const rows = await api.getWebhookDeliveries(id);
    setDeliveries({ webhookId: id, rows });
  };

  return (
    <div>
      <div className="page-header">
        <div><div className="breadcrumb">Verwaltung</div><h2>Webhooks</h2></div>
      </div>
      <div className="content">
        <div className="card" style={{ marginBottom: 20 }}>
          <div className="card-header"><h3>Registrierte Webhooks</h3></div>
          <table className="table">
            <thead><tr><th>Ziel-URL</th><th>Events</th><th>Status</th><th></th></tr></thead>
            <tbody>
              {webhooks.map(w => (
                <tr key={w.id}>
                  <td className="text-mono" style={{ fontSize: 12 }}>{w.ziel_url}</td>
                  <td style={{ fontSize: 12 }}>{w.aktive_events}</td>
                  <td>{w.aktiv ? <span className="badge badge-durchgefuehrt">Aktiv</span> : <span className="badge badge-abgesagt">Inaktiv</span>}</td>
                  <td className="actions">
                    <button className="btn btn-ghost btn-sm" onClick={() => zeigen(w.id)}>Verlauf</button>
                    <button className="btn btn-ghost btn-sm" style={{ color: "var(--danger)" }} onClick={() => loeschen(w.id)}>Löschen</button>
                  </td>
                </tr>
              ))}
              {webhooks.length === 0 && (
                <tr><td colSpan={4} style={{ textAlign: "center", color: "var(--ink-faint)", padding: 24 }}>Keine Webhooks registriert.</td></tr>
              )}
            </tbody>
          </table>
        </div>

        {deliveries && (
          <div className="card" style={{ marginBottom: 20 }}>
            <div className="card-header"><h3>Zustellungsverlauf</h3></div>
            <table className="table">
              <thead><tr><th>Event</th><th>Status-Code</th><th>Erfolgreich</th><th>Zeitpunkt</th></tr></thead>
              <tbody>
                {deliveries.rows.map(d => (
                  <tr key={d.id}>
                    <td>{d.event_typ}</td>
                    <td>{d.status_code ?? "—"}</td>
                    <td>{d.erfolgreich ? <span className="badge badge-durchgefuehrt">Ja</span> : <span className="badge badge-geschlossen_beschlussunfaehig">Nein</span>}</td>
                    <td style={{ fontSize: 12, color: "var(--ink-soft)" }}>
                      {d.zeitpunkt && new Date(d.zeitpunkt).toLocaleString("de-DE")}
                    </td>
                  </tr>
                ))}
                {deliveries.rows.length === 0 && (
                  <tr><td colSpan={4} style={{ textAlign: "center", color: "var(--ink-faint)", padding: 24 }}>Noch keine Zustellungen.</td></tr>
                )}
              </tbody>
            </table>
          </div>
        )}

        <div className="card">
          <div className="card-header"><h3>Neuen Webhook anlegen</h3></div>
          <div className="card-body">
            <FormGroup label="Ziel-URL">
              <input className="form-control" placeholder="https://example.com/hook" value={neuUrl} onChange={e => setNeuUrl(e.target.value)} />
            </FormGroup>
            <FormGroup label="Secret (für HMAC-Signatur)">
              <input className="form-control" value={neuSecret} onChange={e => setNeuSecret(e.target.value)} />
            </FormGroup>
            <FormGroup label="Events (kommagetrennt)">
              <input className="form-control" placeholder="resolution.completed,meeting.created" value={neuEvents} onChange={e => setNeuEvents(e.target.value)} />
            </FormGroup>
            <button className="btn btn-primary" onClick={anlegen}>Webhook anlegen</button>
          </div>
        </div>
      </div>
    </div>
  );
}
